import { createContext } from 'react';

import type { UseNectarAnalyticsReturn } from '~/hooks/useNectarAnalytics';

export const NectarAnalyticsContext = createContext<UseNectarAnalyticsReturn | undefined>(undefined);
